import {
  FETCH_ATTENDANCE_ADMIN_REQUEST,
  FETCH_ATTENDANCE_ADMIN_SUCCESS,
  FETCH_ATTENDANCE_ADMIN_FAILURE,
} from "../constants/AttendanceAdminConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const AttendanceAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ATTENDANCE_ADMIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ATTENDANCE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_ATTENDANCE_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AttendanceAdminReducer;
